import React from 'react';
import { withLoadingHandler } from '../integration-wrapper';

import { GreetingUi } from './ui';
import { useGreeting } from './useGreeting';
import { useCustomer } from '../../auth/customer';

const GreetingWithHandlers = withLoadingHandler(GreetingUi);

export const Greeting: React.FC = () => {
    const { data: greeting, isLoading: greetingLoading } = useGreeting();
    const { data: customerId, isLoading: customerIdLoading } = useCustomer();

    return (
        <GreetingWithHandlers
            isLoading={greetingLoading || customerIdLoading}
            greeting={greeting}
            customerId={customerId}
        />
    );
};
